<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      门店管理
      <small>
        /&nbsp;
        <router-link to="/storelist" class="TitleStyle">门店列表</router-link>/&nbsp;
        <router-link to="/selesclerklist" class="TitleStyle">店员列表</router-link>/&nbsp;店员详情
      </small>
    </h1>
    <!-- end col-6 -->
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->
        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">店员详情</h4>
              </div>
              <!-- end panel-heading -->
              <div class="OrderInfo">
                <div class="OrderGroup">
                    <div class="GTitle">
                    <!-- <span class="TInfo">基本信息</span> -->
                  </div>
                  <div class="GContent">
                    <ul class="GContentUl">


                      <li class="TableContent">
                        <span class="TCode">员工名称：</span>
                        <span class="TCodeContent">{{SelesList.shooperName}}</span>
                      </li>

                      <li class="TableContent">
                        <span class="TCode">联系方式：</span>
                        <span class="TCodeContent">{{SelesList.shooperTel}}</span>
                      </li>


                      <li class="TableContent">
                        <span class="TCode">邀请码：</span>
                        <span class="TCodeContent">{{SelesList.shoperIvcode}}</span>
                      </li>
                       <li class="TableContent">
                        <span class="TCode">职位：</span>
                        <span class="TCodeContent">{{SelesList.shoperrole}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode"> 账户名称：</span>
                        <span class="TCodeContent">{{payAccountInfos.trueName}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">银行卡号：</span>
                        <span class="TCodeContent">{{payAccountInfos.bankCard}}</span>
                      </li>
                        <li class="TableContent">
                        <span class="TCode">开户银行：</span>
                        <span class="TCodeContent">{{SelesList.bankName}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">银行所属省：</span>
                        <span class="TCodeContent">{{payAccountInfos.bankProvince}}</span>
                      </li>

                      <li class="TableContent">
                        <span class="TCode">银行所属城市：</span>
                        <span class="TCodeContent">{{payAccountInfos.bankCity}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">开户支行：</span>
                        <span class="TCodeContent">{{payAccountInfos.bankBranchName}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">持卡人身份证号:</span>
                        <span class="TCodeContent">{{payAccountInfos.idCard}}</span>
                      </li>
                       <li class="TableContent">
                        <span class="TCode">持卡人手机号：</span>
                        <span class="TCodeContent">{{payAccountInfos.bankTel}}</span>
                      </li>
                      <li class="clear"></li>
                    </ul>
                  </div>
                  <div style="height:46px;padding-top:16px;">
                    <a
                      class="btn btn-primary m-r-5"
                      style="float:right;cursor:pointer;color:#fff !important"
                      @click="Goback"
                    >返&nbsp;&nbsp;回</a>

                    <span class="clear"></span>
                  </div>
                </div>
              </div>
            </div>
            <!-- end panel -->
          </div>

          <!-- end col-10 -->
        </div>

        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
  </div>
</template>
<script>
import Qs from "qs";
import axios from "axios";
import http from "@/common/http";

export default {
  name: "InventoryDetailList",
  data() {
    return {
      SelesList: [],
      payAccountInfos:{},
      shoperId:'',
      pageNo:1,
      pageSize: 10,
      shopId:'',
      recom_id:'',
      companyId:''
    };
  },
  mounted: function() {
    if(this.$route.query.recomId){
      this.recom_id = this.$route.query.recomId;
    }
    if(this.$route.query.companyId){
      this.companyId = this.$route.query.companyId;
    }
    this.initdata();
  },
  methods: {
    Goback() {
      this.$router.push({ name: "SelesClerkList" , query: {recomId: this.recom_id,companyId: this.companyId}, params: { pageNo : this.pageNo , pagesize:this.pageSize,shopId: this.shopId}});
    },
    initdata() {
      let that = this;
      if(localStorage.getItem('goodlist')){
        let goodlist = localStorage.getItem('goodlist');
        this.shoperId = JSON.parse(goodlist).shoperId;
        this.pageNo = JSON.parse(goodlist).pageNo;
        this.pageSize = JSON.parse(goodlist).pageSize;
        this.shopId = JSON.parse(goodlist).shopId
        const options = {
          url: "distribution/distribution/selectB2cO2oshoperById",
          method: "post",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          data: Qs.stringify({
            shoperId:JSON.parse(localStorage.getItem('goodlist')).shoperId
          })
        };
        axios(options).then(function(response) {
          if (response.data.code == 200) {

            if(response.data.data.shoperRole === 1){
              response.data.data.shoperrole = '员工'
            }else if(response.data.data.shoperRole === 2){
                response.data.data.shoperrole = '店长'
            }else if(response.data.data.shoperRole === 3){
                response.data.data.shoperrole = '老板'
            }

            that.SelesList = response.data.data;
            that.payAccountInfos = JSON.parse(response.data.data.payAccountInfos);


          } else {
              http.handleEorrorCode(response,that);
          }
        });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ModelPadding {
  margin-top: -30px;
}
.LineSpacing {
  margin-top: 16px;
}
.ButtonColor {
  color: #fff !important;
}

.OrderInfo {
  padding: 20px 30px;
}
.GTitle {
  border-top: 3px #84caf3 solid;
  overflow: hidden;
  line-height: 25px;
  border-right: 1px #e5e5e5 solid;
  background: #f4f4f4;
}
.TInfo {
  position: relative;
  min-width: 130px;
  float: left;
  font-size: 16px;
  padding: 5px 15px;
  background-color: #84caf3;
  color: #ffffff;
}
.GContent {
  padding: 15px;
  border: 1px #e5e5e5 solid;
  border-top: none;
}

.TitleStyle {
  color: #6a7786;
}
@media screen and (min-width:1360px) and (max-width:1680px){ /*二栏布局*/ .TableContent{width: 50%;}  }
@media screen and (min-width:1680px) and (max-width:2000px){ /*二栏布局*/ .TableContent{width: calc(100%/3);}  }
.TableContent {
  float: left;
}
.GContentUl {
  list-style: none;
}
.TCode {
  color: #999999;
  text-align: left;
  width: 120px;
  overflow: hidden;
  font-size: 14px;
  float: left;
  padding-left: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.TCodeContent {
  font-size: 12px;
  float: left;
  width: calc(100% - 120px);
  line-height: 20px;
  text-align: left;
  word-break: normal;
  word-wrap: break-word;
  padding-top: 8px;
  padding-bottom: 8px;
}
.GContent {
  padding: 15px;
  border: 1px #e5e5e5 solid;
  border-top: none;
}
.tableAll,
.tableOne,
.tableSku {
  font-size: 14px;
  margin-bottom: 0;
}
.tableAll > tbody > tr > td {
  border: none;
  width: 25%;
  padding: 5px 15px;
}
.tableAll > tbody > tr {
  text-align: left;
}
.tableOne {
  border: 1px #e5e5e5 solid;
}
.tbheader {
  background: #f4f4f4;
  text-align: left;
}
.tbone {
  border: 1px #e5e5e5 solid;
}
.trbottom > td {
  border-bottom: none;
}
.tdprice {
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/StoreManage/SelesDetail.vue